import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { NotificationInline } from '../../../../../Notification'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { QA_NAME_APPLICANT_IDENTITY_MASKED_NOTICE } from '../ApplicantIdentityWidget.constants'
import {
  getApplicantIdentityContactRows,
  getApplicantIdentityMaskedNotice,
  getHasApplicantIdentityRevealActions,
} from '../ApplicantIdentityWidget.utils'
import { ApplicantIdentityWidgetContactRow } from '../ApplicantIdentityWidgetContactRow'
import { ApplicantIdentityWidgetMessage } from '../ApplicantIdentityWidgetMessage'
import { ApplicantIdentityWidgetName } from '../ApplicantIdentityWidgetName'
import { ApplicantIdentityWidgetRevealActions } from '../ApplicantIdentityWidgetRevealActions'

import * as styles from './ApplicantIdentityWidgetReadView.module.css'

function ApplicantIdentityWidgetReadView() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const maskedNotice = getApplicantIdentityMaskedNotice({ applicantData, t })

  return (
    <div className={styles.ApplicantIdentityWidgetReadView}>
      {maskedNotice ? (
        <NotificationInline
          qaName={QA_NAME_APPLICANT_IDENTITY_MASKED_NOTICE}
          text={maskedNotice}
          type={NOTIFICATION_TYPE.warning}
        />
      ) : null}
      <div className={styles.rows}>
        <ApplicantIdentityWidgetName />
        {getApplicantIdentityContactRows({ applicantData, t }).map(row => (
          <ApplicantIdentityWidgetContactRow {...row} key={row.name} />
        ))}
        <ApplicantIdentityWidgetMessage />
      </div>
      {getHasApplicantIdentityRevealActions(applicantData) ? (
        <ApplicantIdentityWidgetRevealActions />
      ) : null}
    </div>
  )
}

export default ApplicantIdentityWidgetReadView
